import React from 'react';
import ListingCarousel from 'components/listing-carousel';
import { ListingHeader, OverviewWrapper } from 'screens/AreaPage/styled';
import { H3 } from 'ds/components/typography';
import { DealType, IBulletin, ICommercialBulletin, MarketplaceType } from 'utils/entities';
import { useLocale } from 'locale';
import { Route } from 'config/routes';
import ArrowLinkIcon from 'assets/svg/link-arrow.svg';
import { ZoneLink } from 'ds/components/link/styled';
import { connect } from 'react-redux';
import { State } from 'store/state';
import { dealTypeSelector } from 'store/state/selectors/search';
import { searchBulletinsByMarketplaceSelector } from 'store/state/selectors/bulletins';
import { marketplaceSelector } from 'store/state/selectors/router';
import { SpacingBlock } from 'components/spacing-block';

interface ListingsSectionProps {
  term: string;
  zoneName?: string;
  type: string;
  areaCityName?: string;
  areaNeighbourhoodName?: string;
  listings: IBulletin[] | ICommercialBulletin[];
  dealType?: DealType;
  marketplace: MarketplaceType;
}

const ListingsSection: React.FC<ListingsSectionProps> = ({
  term,
  zoneName,
  type,
  areaCityName = null,
  areaNeighbourhoodName = null,
  listings,
  dealType,
  marketplace,
}) => {
  const { t } = useLocale();

  if (!listings || listings.length === 0) return null;

  const isCommercial = marketplace === MarketplaceType.Commercial;

  return (
    <OverviewWrapper data-auto="properties-for-sale">
      <ListingHeader>
        <H3 weight="bold">{t('localPage.listings.title', { type, areaName: areaCityName || areaNeighbourhoodName, dealType })}</H3>
        <SpacingBlock mTop={0.5} />
        <ZoneLink
          data-auto="all-city-nghb-listings"
          preserveParams
          routeName={isCommercial ? Route.SearchCommercial : Route.Search}
          routeParams={{ term: [ term ], dealType: isCommercial ? dealType : DealType.Buy }}
          hideLinkParams
        >
          {t('localPage.listings.seeMore', { type, zoneName })}
          <ArrowLinkIcon />
        </ZoneLink>
      </ListingHeader>
      <ListingCarousel />
    </OverviewWrapper>
  );
};

const mapStateToProps = (state: State) => ({
  listings: searchBulletinsByMarketplaceSelector(state),
  dealType: dealTypeSelector(state),
  marketplace: marketplaceSelector(state),
});

export default connect(mapStateToProps)(ListingsSection);
